import type { AuthorizeStoreStateType } from "./authorize.types";

export const initialAuthorizeState: AuthorizeStoreStateType = {
  token: "",
  name: "",
};
